// Cross Referencing between Jobs and Cleass

export interface IoverlayOption {
  // isActive: boolean
  // link: string
  // trackingEvent: {
  //   micrositeName: string
  //   micrositePhase: string
  // }
  disabledPages: string[]
}

export const overlayOption: IoverlayOption = {
  // isActive: true,
  // link: '/micro-site/gowest',
  // trackingEvent: {
  //   micrositeName: 'Go West!',
  //   micrositePhase: '2',
  // },
  disabledPages: ['/marvel-machine-test', '/marvel-machine', '/events/pixel-picks'],
}
